import React from "react";

const TextareaInput = React.forwardRef(
	(
		{
			label,
			required,
			placeholder,
			hideLabel,
			error,
			onChange,
			value,
			name,
			onBlur,
			rows = 4,
			cols,
		},
		ref
	) => {
		return (
			<div className="form-field">
				{!hideLabel && (
					<label className="field-label">
						{label}
						{required && <span className="required">*</span>}
					</label>
				)}

				<textarea
					ref={ref}
					placeholder={placeholder}
					required={required}
					className={error ? "error" : ""}
					name={name}
					onChange={onChange}
					onBlur={onBlur}
					rows={rows}
					cols={cols}
				/>

				{error && <div className="field__error">{error.message}</div>}
			</div>
		);
	}
);

export default TextareaInput;
